import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const PATTERN_SEARCH_REQUEST = 'PATTERN_SEARCH_REQUEST';
export const PATTERN_SEARCH_SUCCESS = 'PATTERN_SEARCH_SUCCESS';
export const PATTERN_SEARCH_ERROR = 'PATTERN_SEARCH_ERROR';

// Powers the appliesToPatternIds typeahead (Supply + variant level) — searches
// by pattern name, returns [{ _id, patternName }], never exposes the raw id to
// the user. Deliberately no shared cancelToken (unlike Header.jsx's global
// search) — multiple PatternPicker instances can be typing concurrently on one
// screen (product-level + one per variant row), and a shared cancel token
// would cancel one picker's request out from under another.
export const patternSearch = (q) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: PATTERN_SEARCH_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/pattern/search`,
                headers: headers,
                params: { q },
            }).then(function (response) {
                dispatch({
                    type: PATTERN_SEARCH_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: PATTERN_SEARCH_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}
